import moment from 'moment';
import { random } from 'lodash';

import {
  AUTH_SESSION,
  AUTH_LOGIN_START,
  AUTH_LOGIN_ERROR,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGOUT,
  AUTH_SIGNUP,
  AUTH_SIGNUP_USER,
  AUTH_SIGNUP_INVITE,
  AUTH_SIGNUP_PROPERTY,
  AUTH_SIGNUP_TYPE,
  AUTH_SIGNUP_ROUTE,
  AUTH_SIGNUP_COMPLETE,
  AUTH_SIGNUP_RESET,
  AUTH_NETWORK_ERROR,
} from './actions';
import { API_STATUS } from '../../constants/status';

const formalizeDate = dateString =>
  moment(dateString, 'YYYY-MM-DD HH:mm:ss Z')
    .utc()
    .toDate();

const initialState = {
  key: 0,
  error: null,
  authenticated: false,
  status: API_STATUS.NONE,

  jwt: '',
  jwtInvalid: '',
  jwtExpired: '',

  userId: 0,
  propertyId: 0,

  inviteId: 0,
  inviteToken: '',
  inviteData: null,
  userData: null,
  propertyData: null,

  signupType: '',
  signupRoute: '',
  prevRoute: '',
  networkErrorData: {
    networkErrorMessage: '',
    showNetworkError: false,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case AUTH_LOGIN_START: {
      return {
        ...state,
        status: API_STATUS.LOADING,
        error: null,

        jwt: '',
        jwtInvalid: '',
        jwtExpired: '',

        userId: 0,
        propertyId: 0,
      };
    }
    case AUTH_LOGIN_SUCCESS: {
      const { payload } = action;
      const { keep_invite } = payload;

      return {
        ...state,
        error: null,
        key: random(0, 100000),
        status: API_STATUS.SUCCESS,
        authenticated: true,
        jwt: payload.token,
        jwtExpired: formalizeDate(payload.token_expiry.date), // date
        jwtInvalid: formalizeDate(payload.token_invalid.date), // date

        userId: payload.userId,
        propertyId: payload.propertyId,

        inviteId: keep_invite ? state.inviteId : 0,
        inviteToken: keep_invite ? state.inviteToken : '',
        inviteData: keep_invite ? state.inviteData : null,
        userData: keep_invite ? state.userData : null,
        propertyData: keep_invite ? state.propertyData : null,

        signupType: keep_invite ? state.signupType : '',
        signupRoute: keep_invite ? state.signupRoute : '',
        prevRoute: '',
      };
    }
    case AUTH_LOGIN_ERROR: {
      const { payload } = action;
      return {
        ...state,
        status: API_STATUS.ERROR,
        error: payload.message,
      };
    }
    case AUTH_SESSION: {
      return {
        ...state,
        status: API_STATUS.SUCCESS,
        authenticated: true,
      };
    }
    case AUTH_LOGOUT: {
      return {
        ...initialState,
      };
    }
    case AUTH_SIGNUP: {
      const { payload } = action;
      return {
        ...state,
        jwt: payload.token,
        jwtExpired: formalizeDate(payload.token_expiry.date), // date
        jwtInvalid: formalizeDate(payload.token_invalid.date), // date

        userData: payload.user,
        propertyData: payload.property,

        userId: payload.user.id,
        propertyId: payload.propertyId,

        property_conflict: payload.property_conflict,
      };
    }
    case AUTH_SIGNUP_RESET: {
      return {
        ...initialState,
      };
    }
    case AUTH_SIGNUP_COMPLETE: {
      return {
        ...state,
        authenticated: true,
        key: random(0, 100000),
        status: API_STATUS.SUCCESS_LOADING,

        inviteId: 0,
        inviteToken: '',
        inviteData: null,
        userData: null,
        propertyData: null,

        signupType: '',
        signupRoute: '',
        prevRoute: '',
      };
    }
    case AUTH_SIGNUP_INVITE: {
      if (!action.payload) {
        return {
          ...state,
          inviteData: null,
          inviteId: 0,
          inviteToken: '',
        };
      }
      return {
        ...state,
        inviteId: action.payload.id,
        inviteToken: action.payload.token,
        inviteData: {
          ...state.inviteData,
          ...action.payload.data,
        },
      };
    }
    case AUTH_SIGNUP_USER: {
      if (!action.payload) {
        return {
          ...state,
          userData: null,
        };
      }
      return {
        ...state,
        userData: {
          ...state.userData,
          ...action.payload,
        },
      };
    }
    case AUTH_SIGNUP_PROPERTY: {
      if (!action.payload) {
        return {
          ...state,
          propertyData: null,
        };
      }
      return {
        ...state,
        propertyData: {
          ...state.propertyData,
          ...action.payload,
        },
        property_conflict: false,
      };
    }
    case AUTH_SIGNUP_TYPE: {
      const { type, clear } = action.payload;
      return {
        ...state,
        signupType: type,
        signupRoute: clear ? '' : state.signupRoute,
        prevRoute: clear ? '' : state.prevRoute,
      };
    }
    case AUTH_SIGNUP_ROUTE: {
      return {
        ...state,
        signupRoute: action.payload,
        prevRoute: state.signupRoute,
      };
    }
    case AUTH_NETWORK_ERROR: {
      const { networkErrorMessage, showNetworkError } = action.payload;
      return {
        ...state,
        networkErrorData: {
          networkErrorMessage,
          showNetworkError,
        },
      };
    }
    default: {
      return state;
    }
  }
};
